import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const dryMassBalance = wrap(
    `${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.Equipment.DryMassBalance`
  );
  const balance = wrap(`${prefix}.OversizeCorrectionData.Balance`);
  return {
    [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: dryMassBalance,
    [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerMass`]: balance,
    [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.WetSoilAndContainerMass`]: balance,
    [`${prefix}.OversizeCorrectionData.TotalSampleWetMass`]: balance,
    [`${prefix}.OversizeCorrectionData.TareAndOversizeMaterialWetMass`]: balance,
    [`${prefix}.OversizeCorrectionData.OversizeMaterialWetMass`]: balance,
  };
};

export default getMeasuredUsingConfig;
